const common = {
  "nav.home": "Home",
  "nav.productSellMore": "Sell More Workshop",
  "nav.productPrompts": "1500+ Prompts",
  "nav.productPhoenix": "Mentoring Fenix Lite",
  "nav.productTrafficPro": "Traffic Pro",
  "nav.productTrafficMaster": "Traffic Master",
  "nav.productWebDesign": "Web Design",
  "nav.productsTitle": "Products",
  "nav.services": "Services",
  "nav.academy": "Academy",
  "nav.portfolio": "Portfolio",
  "nav.about": "About",
  "nav.resources": "Resources",
  "nav.contact": "Contact",
  "nav.bookCall": "Book a Consultation",
  "nav.toggleMenu": "Toggle menu",

  "footer.tagline": "Transforming Businesses into Profitable Brands with Marketing, Artificial Intelligence and Automation. We build systems that generate more clients and more sales.",
  "footer.services": "Services",
  "footer.products": "Products",
  "footer.company": "Company",
  "footer.marketingStrategy": "Marketing Strategy",
  "footer.metaAds": "Meta Ads",
  "footer.googleAds": "Google Ads",
  "footer.webDesign": "Web Design",
  "footer.automation": "Automation",
  "footer.aiSolutions": "AI Solutions",
  "footer.sellMoreWorkshop": "Sell More Workshop",
  "footer.prompts": "1500+ Prompts",
  "footer.phoenixLite": "Phoenix Lite",
  "footer.trafficPro": "Traffic Pro",
  "footer.trafficMaster": "Traffic Master",
  "footer.webDesignPlans": "Web Design Plans",
  "footer.aboutUs": "About Us",
  "footer.successStories": "Success Stories",
  "footer.contact": "Contact",
  "footer.rights": "All rights reserved.",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Service",

  "hero.tag": "AI-Powered Digital Marketing Agency",
  "hero.mainTitlePart1": "We Build Digital Systems That Generate",
  "hero.mainTitleHighlight1": "Clients",
  "hero.mainTitlePart2": "and",
  "hero.mainTitleHighlight2": "Sales",
  "hero.mainTitlePart3": "Every Day.",
  "hero.subheadline": "We combine strategy, digital advertising, web design, automation and artificial intelligence to build a growth ecosystem that generates measurable results.",
  "hero.ctaPrimary": "I Want a Free Consultation",
  "hero.ctaSecondary": "See How We Work",
  "hero.trust1": "Customized Strategies",
  "hero.trust2": "Measurable Results",
  "hero.trust3": "Intelligent Automation",
  "hero.trust4": "Scalable Growth",
  "hero.stat1": "Businesses Helped",
  "hero.stat2": "Satisfaction",
  "hero.stat3": "Years Experience",
  "hero.stat4": "Revenue Generated",
  "hero.scroll": "Scroll",

  "stats.businesses": "Businesses Helped",
  "stats.satisfaction": "Client Satisfaction",
  "stats.revenue": "Revenue Generated (USD)",
  "stats.experience": "Years of Experience",

  "services.tag": "Why Choose Us",
  "services.title": "Everything You Need to",
  "services.titleHighlight": "Scale Your Business",
  "services.subtitle": "From strategy to execution, we provide a complete ecosystem of marketing services designed for measurable growth.",
  "services.strategy": "Marketing Strategy",
  "services.strategyDesc": "Data-driven strategies tailored to your business goals. We analyze your market, competitors, and audience to build a roadmap for sustainable growth.",
  "services.metaAds": "Meta Ads",
  "services.metaAdsDesc": "High-converting Facebook and Instagram campaigns. We optimize targeting, creatives, and budgets to maximize ROAS and lower acquisition costs.",
  "services.googleAds": "Google Ads",
  "services.googleAdsDesc": "Search, Display, and YouTube campaigns that capture high-intent customers. We dominate your niche with precision targeting.",
  "services.automation": "Automation",
  "services.automationDesc": "Streamline your operations with n8n workflows, CRM integrations, and smart automations that save time and reduce manual work.",
  "services.ai": "Artificial Intelligence",
  "services.aiDesc": "Leverage AI chatbots, predictive analytics, and intelligent content creation to stay ahead of competitors and delight customers.",
  "services.webDesign": "Premium Web Design",
  "services.webDesignDesc": "Conversion-focused websites that load fast, look stunning, and turn visitors into customers. Built with the latest technologies.",
  "services.funnels": "Sales Funnels",
  "services.funnelsDesc": "Engineered funnels that guide prospects from awareness to purchase. Every step optimized for maximum conversion rates.",
  "services.leads": "Lead Generation",
  "services.leadsDesc": "Multi-channel lead generation systems that consistently fill your pipeline with qualified, ready-to-buy prospects.",
  "services.learnMore": "Learn more",

  "products.tag": "Our Products",
  "products.title": "Solutions That",
  "products.titleHighlight": "Drive Results",
  "products.subtitle": "Choose the right solution for your business stage and goals.",
  "products.popular": "Popular",
  "products.sellMore": "Sell More Workshop",
  "products.sellMorePrice": "$9.9 USD",
  "products.sellMoreDesc": "Learn to create your advertising campaigns in three stages: market research, AI-powered ad creation, campaign setup and metrics analysis.",
  "products.prompts": "1500+ Advertising Prompts",
  "products.promptsPrice": "$7.9 USD",
  "products.promptsDesc": "Ready-to-use AI prompts for Meta, Google, and TikTok ads that boost your visibility.",
  "products.phoenix": "Mentoring Fenix Lite",
  "products.phoenixPrice": "$67 USD",
  "products.phoenixDesc": "One-on-one mentoring to level up your marketing skills and business strategy.",
  "products.trafficPro": "Traffic Pro",
  "products.trafficProPrice": "$137 USD",
  "products.trafficProDesc": "Done-for-you traffic generation system that drives more sales for your business.",
  "products.trafficMaster": "Traffic Master",
  "products.trafficMasterPrice": "$470 USD/mo",
  "products.trafficMasterDesc": "Enterprise-grade traffic management with advertising strategies and content calendar planning.",
  "products.webDesign": "Premium Web Design",
  "products.webDesignPrice": "From $277 USD",
  "products.webDesignDesc": "Conversion-optimized websites that turn visitors into paying customers.",
  "products.buyNow": "Buy Now",
  "products.download": "Download",
  "products.joinNow": "Join Now",
  "products.hireNow": "Hire Now",
  "products.bookConsultation": "Book a Consultation",
  "products.viewPlans": "View Plans",

  "portfolio.tag": "Portfolio",
  "portfolio.title": "Work That",
  "portfolio.titleHighlight": "Speaks for Itself",
  "portfolio.subtitle": "Real results from real clients. Here's what happens when strategy meets execution.",
  "portfolio.project1": "E-Commerce Redesign",
  "portfolio.project1Cat": "Web Design + Meta Ads + AI",
  "portfolio.project1Desc": "We transformed an online store into a sales machine.",
  "portfolio.project1Stat": "Revenue Increase",
  "portfolio.project2": "Lead Generation System",
  "portfolio.project2Cat": "Automation",
  "portfolio.project2Desc": "Built an automated lead gen funnel that delivers 200+ qualified leads monthly.",
  "portfolio.project2Stat": "Monthly Leads",
  "portfolio.project3": "Brand Transformation",
  "portfolio.project3Cat": "Strategy + AI Content",
  "portfolio.project3Desc": "Repositioned a traditional business as a digital-first brand with AI-powered content.",
  "portfolio.project3Stat": "Brand Awareness",

  "success.tag": "Success Stories",
  "success.title": "Real Results,",
  "success.titleHighlight": "Real Growth",
  "success.subtitle": "See how we've helped businesses transform their marketing and scale their revenue.",
  "success.ecommerce": "E-Commerce",
  "success.saas": "Web Design",
  "success.professional": "Professional Services",
  "success.challenge": "Challenge",
  "success.strategy": "Strategy",
  "success.execution": "Execution",
  "success.results": "Results",
  "success.prev": "Previous",
  "success.next": "Next",
  "success.story1Challenge": "A retail business struggling with declining foot traffic and low online presence.",
  "success.story1Strategy": "Developed a multi-channel digital strategy combining Meta Ads, website, and a new e-commerce site.",
  "success.story1Execution": "Launched targeted campaigns, built optimized landing pages, and implemented automation for your business.",
  "success.story1Results": "340% increase in online revenue within 6 months. 200+ new qualified leads per month.",
  "success.story1Quote": "Santi and his team transformed our business completely. We went from struggling to thriving in just months.",
  "success.story1Name": "María González",
  "success.story1Role": "CEO, Fashion Company",
  "success.story2Challenge": "Position a brand online to increase sales.",
  "success.story2Strategy": "Implemented a data-driven strategy with AI-optimized bidding and retargeting funnels.",
  "success.story2Execution": "Built automated lead scoring, deployed smart bidding, and optimized landing pages through A/B testing.",
  "success.story2Results": "Reduced cost per acquisition by 62% while scaling monthly signups from 200 to 1,500.",
  "success.story2Quote": "The systems Santi built are still paying dividends. Our growth trajectory completely changed after working with him.",
  "success.story2Name": "Carlos Mendoza",
  "success.story2Role": "Founder, Tech Company",
  "success.story3Challenge": "A professional services firm needed to establish authority and generate high-ticket leads.",
  "success.story3Strategy": "Created an authority-building content strategy with AI-powered content, SEO, and Meta ads automation.",
  "success.story3Execution": "Published 50+ optimized articles, grew Meta ads following, and built an automated system.",
  "success.story3Results": "Secured 15 high-ticket clients worth $450K+ in the first year. 520% increase in organic traffic.",
  "success.story3Quote": "We used to invest in advertising without a clear strategy. With Santi Ospina Marketer we built a complete system that integrates campaigns, automation, and an optimized website. Today we have a much more organized sales process with measurable results.",
  "success.story3Name": "Ana Lucía Ruiz",
  "success.story3Role": "Managing Partner, Real Estate",

  "testimonials.tag": "Testimonials",
  "testimonials.title": "What Our",
  "testimonials.titleHighlight": "Clients Say",
  "testimonials.subtitle": "Don't take our word for it. Here's what business owners say about working with us.",
  "testimonials.prev": "Previous testimonial",
  "testimonials.next": "Next testimonial",
  "testimonials.1quote": "Working with Santi Ospina was a game-changer for our business. In just 3 months, our Meta Ads ROAS went from 1.2x to 4.8x. The automation systems they built save us 20+ hours every week.",
  "testimonials.1name": "Diego Ramírez",
  "testimonials.1role": "CEO, Tech Company",
  "testimonials.2quote": "The website Santi designed for us didn't just look beautiful - it converts. Our conversion rate jumped from 1.8% to 6.2%. The ROI has been incredible. Best investment we've made in years.",
  "testimonials.2name": "Laura Castillo",
  "testimonials.2role": "Marketing Director, Supplement Company",
  "testimonials.3quote": "After struggling with Meta Ads for years, Santi's team optimized our campaigns and cut our CPA by 65% while doubling our lead volume. The AI tools they implemented are revolutionary.",
  "testimonials.3name": "Andrés Mejía",
  "testimonials.3role": "Founder, Snack Company",
  "testimonials.4quote": "Santi doesn't just do marketing - he builds systems. Our entire lead generation is now automated. We wake up to qualified leads in our inbox every single morning. Absolutely transformative.",
  "testimonials.4name": "Carolina Vargas",
  "testimonials.4role": "Owner, Law Firm",
  "testimonials.5quote": "The Traffic Pro system generated more leads in our first month than we got in the previous 6 months combined. Santi's approach to data-driven marketing is on another level.",
  "testimonials.5name": "Felipe Torres",
  "testimonials.5role": "Director, Construction Company",

  "process.tag": "Our Process",
  "process.title": "How We",
  "process.titleHighlight": "Deliver Results",
  "process.subtitle": "A proven 7-step framework that turns your marketing investment into measurable business growth.",
  "process.step1": "Discovery",
  "process.step1Desc": "We dive deep into your business, audience, competitors, and goals to understand exactly what drives growth.",
  "process.step2": "Strategy",
  "process.step2Desc": "We craft a data-backed marketing strategy tailored to your unique position, budget, and growth targets.",
  "process.step3": "Design",
  "process.step3Desc": "Our creative team designs compelling assets, landing pages, and ad creatives that capture attention and convert it into real sales.",
  "process.step4": "Development",
  "process.step4Desc": "We build high-performance websites, funnels, and automation systems engineered for speed and conversion.",
  "process.step5": "Launch",
  "process.step5Desc": "Campaigns go live with precision targeting, optimized budgets, and real-time tracking dashboards.",
  "process.step6": "Optimization",
  "process.step6Desc": "Continuous A/B testing, data analysis, and iterative improvements to maximize ROAS and lower acquisition costs.",
  "process.step7": "Scaling",
  "process.step7Desc": "Once metrics are profitable, we scale aggressively across channels while maintaining efficiency.",

  "cta.title": "Ready to",
  "cta.titleHighlight": "Scale Your Business",
  "cta.titleEnd": "?",
  "cta.subtitle": "Let's build the marketing systems that will transform your business. Book a free strategy call and discover what's possible.",
  "cta.button1": "Book Consultation",
  "cta.button2": "Contact via WhatsApp",
  "cta.trust1": "100% Satisfaction Guaranteed",
  "cta.trust2": "Free 30-Min Strategy Call",
  "cta.trust3": "Results in 30 Days or Less",

  "contact.tag": "Get In Touch",
  "contact.title": "Let's",
  "contact.titleHighlight": "Talk About",
  "contact.subtitle": "Your Business",
  "contact.contactSubtitle": "Schedule a free 15-minute strategy call. We'll discuss your goals, challenges, and how we can help you scale.",
  "contact.whatsapp": "WhatsApp",
  "contact.email": "Email",
  "contact.location": "Location",
  "contact.locationValue": "Colombia - Serving Clients Worldwide",
  "contact.formTitle": "Request Your Free Strategy Call",
  "contact.fullName": "Full Name",
  "contact.namePlaceholder": "Your full name",
  "contact.emailLabel": "Email Address",
  "contact.emailPlaceholder": "you@company.com",
  "contact.company": "Company",
  "contact.companyPlaceholder": "Your company name",
  "contact.phone": "Phone",
  "contact.phonePlaceholder": "300 000 0000",
  "contact.countryCode": "Country Code",
  "contact.service": "Service Interested In",
  "contact.servicePlaceholder": "Select a service",
  "contact.serviceStrategy": "Marketing Strategy",
  "contact.serviceMetaAds": "Meta Ads",
  "contact.serviceGoogleAds": "Google Ads",
  "contact.serviceAutomation": "Automation & AI",
  "contact.serviceWebDesign": "Web Design",
  "contact.serviceTrafficPro": "Traffic Pro",
  "contact.serviceTrafficMaster": "Traffic Master",
  "contact.serviceMentoring": "Phoenix Lite Mentoring",
  "contact.serviceOther": "Other",
  "contact.message": "Message",
  "contact.messagePlaceholder": "Tell us about your business and goals...",
  "contact.charLimit": "Max 500 characters",
  "contact.submit": "Book My Free Strategy Call",
  "contact.sending": "Sending...",
  "contact.success": "Thank you! We'll get back to you within 24 hours.",
  "contact.networkError": "Network error. Please try again.",

  "lang.es": "ES",
  "lang.en": "EN",

  "phoenix.badge": "🔥 Exclusive Program 3 sessions for",
  "phoenix.heroTitle": "Fenix Lite Mentoring",
  "phoenix.heroHeadline": "Learn to build profitable campaigns with Artificial Intelligence and Meta Ads, working directly with me.",
  "phoenix.heroSubtitle": "This is not a traditional mentorship. During three private sessions, we will build a personalized strategy for your business together. You will learn to research your market using Artificial Intelligence, create professional ads, and launch campaigns that actually generate clients.",
  "phoenix.feature1": "100% Personalized Mentoring",
  "phoenix.feature2": "1-on-1 Work",
  "phoenix.feature3": "Real Cases",
  "phoenix.feature4": "Limited Spots",
  "phoenix.price": "171 USD",
  "phoenix.pricePerSession": "EACH SESSION AT 67 USD",
  "phoenix.ctaPrimary": "Reserve My Spot",
  "phoenix.ctaSecondary": "View Program",
  "phoenix.ctaBuySessions": "I want to purchase the 3 sessions",
  "phoenix.trust1": "Secure Payment",
  "phoenix.trust2": "Immediate Access",
  "phoenix.trust3": "Personalized Attention",

  "phoenix.transformationTag": "From beginner to digital strategist",
  "phoenix.transformationTitle": "By the end of the Phoenix Lite™ Program, you will be able to:",
  "phoenix.transformation1": "Design a professional strategy",
  "phoenix.transformation2": "Use AI to research markets",
  "phoenix.transformation3": "Create high-impact ads",
  "phoenix.transformation4": "Set up professional campaigns",
  "phoenix.transformation5": "Analyze metrics correctly",
  "phoenix.transformation6": "Scale profitable campaigns",

  "phoenix.methodTag": "Phoenix Method™",
  "phoenix.phase1Title": "Strategic Diagnosis",
  "phoenix.phase1Time": "2 hours",
  "phoenix.phase1Item1": "Business analysis",
  "phoenix.phase1Item2": "Ideal client",
  "phoenix.phase1Item3": "Competition",
  "phoenix.phase1Item4": "Objectives",
  "phoenix.phase1Item5": "Strategy design",
  "phoenix.phase1Desc": "We will end this session with a fully defined strategy for your business.",
  "phoenix.phase2Title": "Applied Artificial Intelligence",
  "phoenix.phase2Time": "2 hours",
  "phoenix.phase2Item1": "AI-powered research",
  "phoenix.phase2Item2": "Prompts",
  "phoenix.phase2Item3": "Ad creation",
  "phoenix.phase2Item4": "Copywriting",
  "phoenix.phase2Item5": "Creatives",
  "phoenix.phase2Item6": "Optimization",
  "phoenix.phase2Desc": "You will learn to use Artificial Intelligence to accelerate the entire campaign creation process.",
  "phoenix.phase3Title": "Professional Implementation",
  "phoenix.phase3Time": "2 hours",
  "phoenix.phase3Item1": "Meta Ads setup",
  "phoenix.phase3Item2": "Campaigns",
  "phoenix.phase3Item3": "Events",
  "phoenix.phase3Item4": "Pixel",
  "phoenix.phase3Item5": "Metrics",
  "phoenix.phase3Item6": "Optimization",
  "phoenix.phase3Item7": "Scaling",
  "phoenix.phase3Desc": "We will finish with a fully functional campaign ready to generate results.",

  "phoenix.includesTag": "What's Included",
  "phoenix.includes1": "3 private sessions",
  "phoenix.includes2": "Over 6 hours of guidance",
  "phoenix.includes3": "Implementation on your own business",
  "phoenix.includes4": "Campaign review",
  "phoenix.includes5": "Direct access to mentor",
  "phoenix.includes6": "Downloadable materials",
  "phoenix.includes7": "Templates",
  "phoenix.includes8": "Resources",

  "phoenix.bonusTag": "Exclusive Bonuses",
  "phoenix.bonusPromptsTitle": "1500+ Advertising Prompts",
  "phoenix.bonusPromptsValue": "7.9 USD",
  "phoenix.bonusPromptsDesc": "Complete pack of ready-to-use AI prompts for Meta, Google, and TikTok. Speed up your ad creation with professional copywriting and optimized creatives.",
  "phoenix.bonusLabel": "Commercial Value",
  "phoenix.bonusHeading": "A gift that <span>accelerates</span> your learning.",

  "phoenix.pricingTag": "Program Value",
  "phoenix.pricingMentoring": "Mentoring",
  "phoenix.pricingMentoringNormal": "Mentoring normal price",
  "phoenix.pricingPrompts": "1500+ Advertising Prompts",
  "phoenix.pricingMentoringNormalValue": "234 USD",
  "phoenix.pricingPromptsValue": "7.9 USD",
  "phoenix.pricingTotal": "Total",
  "phoenix.pricingToday": "Today",
  "phoenix.pricingSave": "You save 75.9 USD",

  "phoenix.forYouTag": "Is this mentoring for you?",
  "phoenix.yesTitle": "YES, it is for you if...",
  "phoenix.yes1": "You have a business",
  "phoenix.yes2": "You want to learn Meta Ads",
  "phoenix.yes3": "You want to use AI",
  "phoenix.yes4": "You want to attract more clients",
  "phoenix.yes5": "You want to stop improvising",
  "phoenix.noTitle": "NO, if...",
  "phoenix.no1": "You expect results without implementing",
  "phoenix.no2": "You don't have time to learn",
  "phoenix.no3": "You don't want to apply strategies",

  "phoenix.aboutTag": "Why learn with me?",
  "phoenix.aboutTitle": "Santiago Ospina",
  "phoenix.aboutRole": "Mentor & Digital Strategist",
  "phoenix.aboutBio": "Over 5 years of experience helping entrepreneurs and businesses scale their sales using Meta Ads and Artificial Intelligence. I have worked with over 100 clients across different industries, combining marketing strategy, automation, and technology to create systems that generate predictable results.",
  "phoenix.aboutSkill1": "Meta Ads",
  "phoenix.aboutSkill2": "Artificial Intelligence",
  "phoenix.aboutSkill3": "Marketing Strategy",
  "phoenix.aboutSkill4": "Automation",
  "phoenix.aboutSkill5": "Web Design",
  "phoenix.aboutSkill6": "Sales Funnels",
  "phoenix.aboutFocus": "Focus on personalized learning and real implementation.",

  "phoenix.resultsTag": "Expected Results",
  "phoenix.results1": "Professional campaigns",
  "phoenix.results2": "Greater confidence",
  "phoenix.results3": "Automated processes",
  "phoenix.results4": "Better ROAS",
  "phoenix.results5": "More clients",
  "phoenix.results6": "Greater productivity",

  "phoenix.faqTag": "Frequently Asked Questions",
  "phoenix.faq1Q": "How does the Phoenix Lite Program work?",
  "phoenix.faq1A": "It consists of three private 2-hour sessions where we work directly on your business. In the first session, we diagnose and design the strategy. In the second, I teach you to use AI to create ads. In the third, we set up your Meta Ads campaigns together.",
  "phoenix.faq2Q": "Do I need prior experience in Meta Ads?",
  "phoenix.faq2A": "No. The program is designed for both beginners and those with some experience. We start from scratch and progress at your pace.",
  "phoenix.faq3Q": "How long do I have to schedule the sessions?",
  "phoenix.faq3A": "You have up to 60 days from purchase to schedule and complete all three sessions. I recommend spacing them with a gap of three days per session so you can implement what you learn.",
  "phoenix.faq4Q": "Are the sessions recorded?",
  "phoenix.faq4A": "Yes, all sessions are recorded and you will have lifetime access to the recordings, along with all downloadable materials.",
  "phoenix.faq5Q": "What do I need ready for the first session?",
  "phoenix.faq5A": "You only need your computer, internet access, and a willingness to learn. Ideally, have your Facebook and Instagram accounts active, but if not, we'll set them up in the first session.",
  "phoenix.faq6Q": "Can I ask questions between sessions?",
  "phoenix.faq6A": "Yes, you will have direct access to me via WhatsApp to resolve specific doubts between sessions. I want to make sure you truly implement everything we learn.",
  "phoenix.faq8Q": "Why only 171 USD?",
  "phoenix.faq8A": "Because my goal is for more entrepreneurs to access quality mentoring without price being a barrier. The real value of the program exceeds $500 USD. It's an investment in your education and business growth.",

  "phoenix.finalTitle": "Don't buy another mentorship.",
  "phoenix.finalSubtitle": "Invest in a system you can use throughout your entire career.",
  "phoenix.finalDesc": "We will work together on your business so you finish with a clear strategy, configured campaigns, and the knowledge needed to keep growing.",
  "phoenix.finalPrice": "171 USD",
  "phoenix.finalCta": "Reserve My Spot",
  "phoenix.finalFeature1": "Personalized Mentoring",
  "phoenix.finalFeature2": "Limited Spots",
  "phoenix.finalFeature3": "Immediate Access",

  "trafficPro.badge": "🚀 Premium Service",
  "trafficPro.heroTitle": "Plan Traffic Pro",
  "trafficPro.heroHeadline": "We launch your first professional campaign to get clients with Meta Ads.",
  "trafficPro.heroSubtitle": "We build an advertising strategy designed for how Meta Ads works today. We create AI-powered images and videos that capture attention, properly configure your advertising ecosystem, and deliver an optimized campaign to generate more sales opportunities — while you learn to interpret metrics to keep growing.",
  "trafficPro.heroFeature1": "Professional Setup",
  "trafficPro.heroFeature2": "Campaign Ready to Publish",
  "trafficPro.heroFeature3": "Initial Optimization",
  "trafficPro.heroFeature4": "Metrics Tracking",
  "trafficPro.ctaPrimary": "I Want to Launch My Campaign",
  "trafficPro.ctaSecondary": "View Plans",
  "trafficPro.ctaWhatsApp": "Chat on WhatsApp",
  "trafficPro.heroSpeedCTA": "I want my ad campaign in 2 days",
  "trafficPro.trust1": "Secure Payment",
  "trafficPro.trust2": "Professional Implementation",
  "trafficPro.trust3": "Delivery in 15 Days",

  "trafficPro.includesTag": "What's Included in Traffic Pro?",
  "trafficPro.includesTitle": "Your Complete",
  "trafficPro.includesTitleHighlight": "Digital Ecosystem",
  "trafficPro.includes1": "Business Manager Setup",
  "trafficPro.includes1Desc": "We create and configure your business operations hub on Meta.",
  "trafficPro.includes2": "Business Portfolio Creation",
  "trafficPro.includes2Desc": "We establish your business's professional identity within the Meta ecosystem.",
  "trafficPro.includes3": "Ad Account Configuration",
  "trafficPro.includes3Desc": "We activate your advertising account with all necessary settings.",
  "trafficPro.includes4": "Ads Manager",
  "trafficPro.includes4Desc": "We structure the control panel from which you'll manage your campaigns.",
  "trafficPro.includes5": "Pixel Setup",
  "trafficPro.includes5Desc": "We install the tracking pixel to measure conversions and optimize.",
  "trafficPro.includes6": "Campaign Creation",
  "trafficPro.includes6Desc": "We design your advertising campaign with clear objectives and professional structure.",
  "trafficPro.includes7": "Audience Targeting",
  "trafficPro.includes7Desc": "We define ideal audiences so your ads reach the right people.",
  "trafficPro.includes8": "Conversion Configuration",
  "trafficPro.includes8Desc": "We set up conversion events to measure results accurately.",
  "trafficPro.includes9": "Initial Optimization",
  "trafficPro.includes9Desc": "We adjust parameters during the first days to improve performance.",
  "trafficPro.includes10": "Metrics Review",
  "trafficPro.includes10Desc": "We analyze the data and deliver a clear performance report.",
  "trafficPro.includes11": "Project Delivery",
  "trafficPro.includes11Desc": "Project ready in Meta Ads.",

  "trafficPro.processTag": "Our Process",
  "trafficPro.processTitle": "How We",
  "trafficPro.processTitleHighlight": "Work",
  "trafficPro.process1Title": "Diagnosis",
  "trafficPro.process1Desc": "We analyze your business and objectives.",
  "trafficPro.process2Title": "Setup",
  "trafficPro.process2Desc": "We create the entire professional structure on Meta.",
  "trafficPro.process3Title": "Design",
  "trafficPro.process3Desc": "We create ads using Artificial Intelligence.",
  "trafficPro.process4Title": "Launch",
  "trafficPro.process4Desc": "We publish the campaign.",
  "trafficPro.process5Title": "Optimization",
  "trafficPro.process5Desc": "We review metrics over the following days.",

  "trafficPro.pricingTag": "Choose Your Plan",
  "trafficPro.pricingTitle": "Transparent",
  "trafficPro.pricingTitleHighlight": "For your business",
  "trafficPro.planAName": "Plan A",
  "trafficPro.planAPrice": "137 USD",
  "trafficPro.planAUsd": "60 USD",
  "trafficPro.planADesc": "Ideal for those who want to get started.",
  "trafficPro.planAItem1": "Complete Meta ecosystem setup",
  "trafficPro.planAItem2": "Professional Campaign",
  "trafficPro.planAItem3": "4 AI-generated images and videos",
  "trafficPro.planAItem4": "Initial optimization",
  "trafficPro.planAItem5": "Metrics review",
  "trafficPro.planATimeline": "2-5 days implementation. 10 days follow-up.",
  "trafficPro.planBName": "Plan B",
  "trafficPro.planBPrice": "300,000 COP",
  "trafficPro.planBUsd": "84 USD",
  "trafficPro.planBDesc": "The most complete option for maximum impact.",
  "trafficPro.planBItem1": "Everything in Plan A",
  "trafficPro.planBItem2": "4 AI-generated videos",
  "trafficPro.planBItem3": "2 additional AI images",
  "trafficPro.planBItem4": "Premium Creatives",
  "trafficPro.planBItem5": "Greater visual impact",
  "trafficPro.planBTimeline": "2-5 days implementation. 10 days follow-up.",
  "trafficPro.popularBadge": "Most Popular",
  "trafficPro.planACta": "Choose Plan A",
  "trafficPro.planBCta": "Choose Plan B",

  "trafficPro.howTag": "How Will We Work?",
  "trafficPro.howTitle": "Collaboration",
  "trafficPro.howTitleHighlight": "Process",
  "trafficPro.how1Title": "50% to start",
  "trafficPro.how1Desc": "You make the first payment to begin the digital ecosystem implementation.",
  "trafficPro.how2Title": "50% upon completion",
  "trafficPro.how2Desc": "The remaining payment is made when the entire project is delivered and running.",
  "trafficPro.how3Title": "Professional delivery",
  "trafficPro.how3Desc": "You receive access to the entire configured ecosystem with detailed documentation.",
  "trafficPro.how4Title": "Follow-up included",
  "trafficPro.how4Desc": "After delivery, we track metrics for 10 days.",
  "trafficPro.how5Title": "Direct communication",
  "trafficPro.how5Desc": "Open communication channel to resolve questions throughout the process.",

  "trafficPro.whyTag": "Why Choose Us?",
  "trafficPro.whyTitle": "Strategic",
  "trafficPro.whyTitleHighlight": "Advantages",
  "trafficPro.why1Title": "Strategic Marketing",
  "trafficPro.why1Desc": "Every campaign is based on deep analysis of your business and target market.",
  "trafficPro.why2Title": "Professional Meta Ads",
  "trafficPro.why2Desc": "Expert configuration with industry best practices and standards.",
  "trafficPro.why3Title": "AI-Powered Creatives",
  "trafficPro.why3Desc": "Images and videos generated with cutting-edge artificial intelligence.",
  "trafficPro.why4Title": "Optimization",
  "trafficPro.why4Desc": "Continuous monitoring and adjustments to improve your investment performance.",
  "trafficPro.why5Title": "Metrics Analysis",
  "trafficPro.why5Desc": "We interpret data to make informed decisions about your campaigns.",
  "trafficPro.why6Title": "Automation",
  "trafficPro.why6Desc": "We implement systems that work for you even while you sleep.",

  "trafficPro.resultsTag": "Expected Results",
  "trafficPro.resultsTitle": "What You",
  "trafficPro.resultsTitleHighlight": "Will Achieve",
  "trafficPro.results1": "Greater visibility",
  "trafficPro.results2": "More potential clients",
  "trafficPro.results3": "Structured campaigns",
  "trafficPro.results4": "Better organization",
  "trafficPro.results5": "Data-driven decisions",
  "trafficPro.results6": "Scalability",

  "trafficPro.faqTag": "Frequently Asked Questions",
  "trafficPro.faq1Q": "What exactly is Traffic Pro Launch?",
  "trafficPro.faq1A": "Traffic Pro Launch is a premium service where we set up your entire Meta Ads ecosystem from scratch: Business Manager, ad account, pixel, professional campaign, and initial optimization. It's not just creating ads — it's building a complete digital system ready to attract clients consistently.",
  "trafficPro.faq2Q": "How long does it take to see results?",
  "trafficPro.faq2A": "Full implementation takes 2-5 business days. Once the campaign is published, we track metrics for 10 days. Initial results start appearing within the first few days of publication, but we recommend waiting at least 7 days for meaningful data to optimize.",
  "trafficPro.faq3Q": "Do I need previous Meta Ads experience?",
  "trafficPro.faq3A": "No. Traffic Pro Launch is designed precisely for business owners who want professional Meta Ads presence without learning all the technical aspects. We handle everything and deliver the ecosystem ready and documented.",
  "trafficPro.faq4Q": "What do the AI-generated images and videos include?",
  "trafficPro.faq4A": "We create professional advertising creatives using artificial intelligence. The Plan includes 2 images and 3 AI-powered videos optimized for Meta Ads, all designed to capture your ideal audience's attention and generate conversions.",
  "trafficPro.faq5Q": "What if I don't have a website or social media?",
  "trafficPro.faq5A": "No problem. We can work with what you have. If you don't have a website, we can configure campaigns oriented to WhatsApp or Messenger conversions. If you need a website, we also offer that service separately.",
  "trafficPro.faq6Q": "How does the 50% initial and 50% final payment work?",
  "trafficPro.faq6A": "You make the first 50% payment to start the project. Once implementation is complete, we review all the work together and you make the remaining 50%. This gives you peace of mind and confidence in the process.",
  "trafficPro.faq7Q": "Do I have full control of my ad accounts?",
  "trafficPro.faq7A": "Yes, absolutely. All accounts are created under your business name and you are the owner. We only need partner or admin access during setup and optimization. Upon completion, you have full control.",
  "trafficPro.faq8Q": "What happens after the 10-day follow-up?",
  "trafficPro.faq8A": "After the follow-up period, we deliver a detailed report with all metrics, recommendations, and insights. If you want ongoing monthly campaign management, we can offer our Traffic Master service, designed for continuous administration.",

  "trafficPro.finalTitle": "Your next campaign could be the difference between constantly looking for clients or starting to attract them consistently.",
  "trafficPro.finalSubtitle": "Let's start building a professional digital ecosystem for your business.",

  "trafficPro.kpiRoas": "ROAS",
  "trafficPro.kpiLeads": "Leads",
  "trafficPro.kpiCtr": "CTR",
  "trafficPro.kpiConversions": "Conversions",

  "trafficMaster.badge": "🚀 Premium Enterprise Service",
  "trafficMaster.heroTitle": "Traffic Master Growth™",
  "trafficMaster.heroHeadline": "Your Digital Marketing Department without hiring an internal team.",
  "trafficMaster.heroSubtitle": "We become your company's strategic partner to create campaigns with tracking, Meta Ads content all month long, and a commercial system designed to generate clients consistently.",
  "trafficMaster.heroSubtitle2": "We don't manage ads. We build a complete growth ecosystem.",
  "trafficMaster.heroFeature1": "Unlimited Campaigns",
  "trafficMaster.heroFeature2": "Ongoing Strategy",
  "trafficMaster.heroFeature3": "Weekly Optimization",
  "trafficMaster.heroFeature4": "Scalable Growth",
  "trafficMaster.ctaPrimary": "Book a Consultation",
  "trafficMaster.ctaSecondary": "See Everything Included",
  "trafficMaster.trust1": "Enterprise Service",
  "trafficMaster.trust2": "Professional Implementation",
  "trafficMaster.trust3": "Ongoing Support",
  "trafficMaster.heroKpiRoas": "ROAS",
  "trafficMaster.heroKpiRevenue": "Revenue",
  "trafficMaster.heroKpiLeads": "Leads",
  "trafficMaster.heroKpiGrowth": "Weekly Growth",

  "trafficMaster.servicesTag": "More than an agency",
  "trafficMaster.servicesTitle": "We are your",
  "trafficMaster.servicesTitleHighlight": "marketing department",
  "trafficMaster.svc1Title": "Unlimited Campaigns",
  "trafficMaster.svc1Desc": "We constantly create and optimize campaigns to maximize the return on your advertising investment.",
  "trafficMaster.svc2Title": "Content Marketing",
  "trafficMaster.svc2Desc": "We publish five monthly content pieces across two social networks with a defined editorial strategy.",
  "trafficMaster.svc3Title": "Professional Website",
  "trafficMaster.svc3Desc": "We build your website using the recommended platform for optimal performance.",
  "trafficMaster.svc4Title": "Automation",
  "trafficMaster.svc4Desc": "We integrate intelligent processes to save time and systematically improve conversion.",
  "trafficMaster.svc5Title": "Weekly Optimization",
  "trafficMaster.svc5Desc": "We analyze metrics weekly and make continuous improvements based on real data.",
  "trafficMaster.svc6Title": "Strategic Consulting",
  "trafficMaster.svc6Desc": "We accompany you in strategic decision-making to scale your business sustainably.",

  "trafficMaster.ecosystemTag": "Our Growth Ecosystem",
  "trafficMaster.ecosystemTitle": "A complete system to",
  "trafficMaster.ecosystemTitleHighlight": "scale your business",
  "trafficMaster.eco1": "Business Strategy",
  "trafficMaster.eco2": "Customer Research",
  "trafficMaster.eco3": "Meta Ads",
  "trafficMaster.eco4": "Website",
  "trafficMaster.eco5": "Landing Pages",
  "trafficMaster.eco6": "Automation",
  "trafficMaster.eco7": "CRM",
  "trafficMaster.eco8": "Lead Nurturing",
  "trafficMaster.eco9": "Sales",
  "trafficMaster.eco10": "Customer Loyalty",

  "trafficMaster.monthlyTag": "Monthly Deliverables",
  "trafficMaster.monthlyTitle": "What will you receive each month?",
  "trafficMaster.del1": "Unlimited Ad Campaigns",
  "trafficMaster.del2": "5 Monthly Posts",
  "trafficMaster.del3": "2 Social Media Accounts Managed",
  "trafficMaster.del4": "Ad Design",
  "trafficMaster.del5": "Ongoing Optimization",
  "trafficMaster.del6": "Weekly Metrics Review",
  "trafficMaster.del7": "Strategic Advisory",
  "trafficMaster.del8": "Professional Website",
  "trafficMaster.del9": "Business Automation",
  "trafficMaster.del10": "Monthly Reports",

  "trafficMaster.processTag": "Our Process",
  "trafficMaster.processTitle": "How we work to grow your business",
  "trafficMaster.stepLabel": "STEP",
  "trafficMaster.process1": "Business Diagnosis",
  "trafficMaster.process1Item1": "We analyze your business objectives",
  "trafficMaster.process1Item2": "We identify growth opportunities",
  "trafficMaster.process2": "Strategic Design",
  "trafficMaster.process2Item1": "We create a customized growth plan",
  "trafficMaster.process2Item2": "We define KPIs and success metrics",
  "trafficMaster.process3": "Implementation",
  "trafficMaster.process3Item1": "We launch advertising campaigns",
  "trafficMaster.process3Item2": "We build the professional website",
  "trafficMaster.process3Item3": "We configure business automation",
  "trafficMaster.process4": "Optimization",
  "trafficMaster.process4Item1": "Weekly metrics review",
  "trafficMaster.process4Item2": "Data-driven adjustments",
  "trafficMaster.process5": "Scaling",
  "trafficMaster.process5Item1": "New growth campaigns",
  "trafficMaster.process5Item2": "Continuous ecosystem improvements",

  "trafficMaster.resultsTag": "Expected Results",
  "trafficMaster.resultsTitle": "Results we aim to achieve together",
  "trafficMaster.result1": "Greater Visibility",
  "trafficMaster.result2": "More Potential Clients",
  "trafficMaster.result3": "Better ROAS",
  "trafficMaster.result4": "Higher Market Position",
  "trafficMaster.result5": "More Sales",
  "trafficMaster.result6": "Full Automation",
  "trafficMaster.result7": "Scalability",

  "trafficMaster.idealTag": "Ideal For",
  "trafficMaster.idealTitle": "Companies that want consistent growth",
  "trafficMaster.ideal1": "Growing Companies",
  "trafficMaster.ideal2": "Personal Brands",
  "trafficMaster.ideal3": "E-commerce",
  "trafficMaster.ideal4": "Service Companies",
  "trafficMaster.ideal5": "Construction Companies",
  "trafficMaster.ideal6": "Clinics",
  "trafficMaster.ideal7": "Restaurants",
  "trafficMaster.ideal8": "Academies",
  "trafficMaster.ideal9": "Real Estate",

  "trafficMaster.comparisonTag": "Comparison",
  "trafficMaster.comparisonTitle": "Why Traffic Master Growth™?",
  "trafficMaster.compFeature": "Feature",
  "trafficMaster.compTraditional": "Traditional Agency",
  "trafficMaster.comp1": "Unlimited campaigns",
  "trafficMaster.comp2": "Weekly optimization",
  "trafficMaster.comp3": "Strategic consulting",
  "trafficMaster.comp4": "Website included",
  "trafficMaster.comp5": "Business automation",
  "trafficMaster.comp6": "Business growth system",

  "trafficMaster.pricingTag": "Investment",
  "trafficMaster.pricingTitle": "Investment in business growth",
  "trafficMaster.pricingWeekly": "Weekly investment",
  "trafficMaster.pricingWeeklyAmount": "250,000 COP",
  "trafficMaster.pricingEquivalent": "Equivalent to",
  "trafficMaster.pricingMonthly": "1,000,000 COP monthly",
  "trafficMaster.pricingMonthlyUsd": "275 USD monthly",
  "trafficMaster.pricingHighlight": "Ideal for companies that want consistent growth",
  "trafficMaster.pricingCta": "Book a Strategic Consultation",

  "trafficMaster.faqTag": "Frequently Asked Questions",
  "trafficMaster.faqTitle": "We answer your questions",
  "trafficMaster.faq1Q": "What exactly is Traffic Master Growth™?",
  "trafficMaster.faq1A": "Traffic Master Growth™ is our premium enterprise service where we become your external marketing department. We don't just manage ads — we build a complete ecosystem that includes unlimited campaigns, content creation, continuous optimization, automation, professional website, and strategic consulting. It's like having a CMO and marketing team working exclusively for your company, without the costs of hiring internal staff.",
  "trafficMaster.faq2Q": "What's the difference between Traffic Pro and Traffic Master?",
  "trafficMaster.faq2A": "Traffic Pro is a one-time service where we set up your Meta Ads ecosystem and launch your first professional campaign. Traffic Master is an ongoing monthly management service where we become your marketing department: unlimited campaigns, content, weekly optimization, automation, and permanent strategic consulting.",
  "trafficMaster.faq3Q": "What exactly do unlimited campaigns include?",
  "trafficMaster.faq3A": "We create, launch, and optimize all advertising campaigns needed to achieve your company's goals. This includes prospecting, retargeting, conversion, website traffic, and lead generation campaigns. There's no limit on the number of active campaigns.",
  "trafficMaster.faq4Q": "Which social networks do you publish content on?",
  "trafficMaster.faq4A": "We work on the two social networks that best suit your business and target audience. Typically Instagram and Facebook, but we can work on LinkedIn, TikTok, or other platforms depending on your strategy. We publish 5 monthly content pieces with professional design.",
  "trafficMaster.faq5Q": "How does weekly optimization work?",
  "trafficMaster.faq5A": "Every week we analyze metrics from all active campaigns, website performance, and business results. Based on this data, we make strategic adjustments to continuously improve ROAS, reduce acquisition costs, and increase client generation.",
  "trafficMaster.faq6Q": "What type of companies are ideal for Traffic Master?",
  "trafficMaster.faq6A": "Traffic Master is designed for companies that already have some level of operation and want to scale consistently and professionally. It's ideal for growing companies, established personal brands, e-commerce, construction companies, clinics, restaurants, academies, real estate agencies, and service companies seeking a predictable growth system.",
  "trafficMaster.faq7Q": "Is there a minimum commitment contract?",
  "trafficMaster.faq7A": "We recommend a minimum commitment of 3 months to build, optimize, and start seeing consistent results. Digital marketing is a process that requires time to mature. However, we work with monthly payments without forced permanence clauses.",
  "trafficMaster.faq8Q": "Who manages my advertising account and website?",
  "trafficMaster.faq8A": "All accounts and digital assets are created under your company's name. You are the absolute owner. Our team operates as administrators during the service period. If you ever decide to end the relationship, we hand everything over with full access and no restrictions.",

  "trafficMaster.finalTag": "Grow with a system, not luck",
  "trafficMaster.finalTitle": "You don't need to hire a marketing department.",
  "trafficMaster.finalTitleHighlight": "You need a system that grows your business.",
  "trafficMaster.finalSubtitle": "Traffic Master Growth™ combines strategy, advertising, content, automation, and analytics to help you consistently attract clients.",
  "trafficMaster.finalCtaPrimary": "Book a Consultation",
  "trafficMaster.finalCtaWhatsApp": "Chat on WhatsApp",
};

export default common;